import { useEffect, useState } from 'react';

export const useScroll = (target: HTMLElement | null) => {
  const [isScrollOnTop, setIsScrollOnTop] = useState(true);
  const [isScrollOnBottom, setIsScrollOnBottom] = useState(true);
  const [hasScrollBar, setHasScrollBar] = useState(false);

  const onScroll = () => {
    if (!target) return;
    setIsScrollOnTop(target.scrollTop === 0);
    // On some screen sizes the difference between the scrollHeight and scrollTop + clientHeight is ~0.5px
    // even though you have scrolled to the bottom, therefore we use the value 1 instead of 0 for comparison.
    setIsScrollOnBottom(Math.abs(target.scrollHeight - (target.scrollTop + target.clientHeight)) <= 1);
    setHasScrollBar(target.scrollHeight > target.clientHeight);
  };

  useEffect(() => {
    onScroll();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [target]);
  return { isScrollOnTop, isScrollOnBottom, onScroll, hasScrollBar };
};
